var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9301 2.5V8.4C14.9301 8.84 14.4101 9.06 14.0901 8.77L12.3401 7.16C12.1501 6.98 11.8501 6.98 11.6601 7.16L9.91007 8.76C9.59007 9.06 9.07007 8.83 9.07007 8.4V2.5C9.07007 2.22 9.29007 2 9.57007 2H14.4301C14.7101 2 14.9301 2.22 14.9301 2.5Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.98 2.06086C16.69 2.02086 16.43 2.27086 16.43 2.56086V8.58086C16.43 9.34086 15.98 10.0309 15.28 10.3409C14.58 10.6409 13.77 10.5109 13.21 9.99086L12.34 9.19086C12.15 9.01086 11.86 9.01086 11.66 9.19086L10.79 9.99086C10.43 10.3309 9.96 10.5009 9.49 10.5009C9.23 10.5009 8.97 10.4509 8.72 10.3409C8.02 10.0309 7.57 9.34086 7.57 8.58086V2.56086C7.57 2.27086 7.31 2.02086 7.02 2.06086C4.22 2.41086 3 4.30086 3 7.00086V17.0009C3 20.0009 4.5 22.0009 8 22.0009H16C19.5 22.0009 21 20.0009 21 17.0009V7.00086C21 4.30086 19.78 2.41086 16.98 2.06086ZM17.5 18.7509H9C8.59 18.7509 8.25 18.4109 8.25 18.0009C8.25 17.5909 8.59 17.2509 9 17.2509H17.5C17.91 17.2509 18.25 17.5909 18.25 18.0009C18.25 18.4109 17.91 18.7509 17.5 18.7509ZM17.5 14.7509H13.25C12.84 14.7509 12.5 14.4109 12.5 14.0009C12.5 13.5909 12.84 13.2509 13.25 13.2509H17.5C17.91 13.2509 18.25 13.5909 18.25 14.0009C18.25 14.4109 17.91 14.7509 17.5 14.7509Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceReportIcon);
export default __webpack_public_path__ + "static/media/performanceReportIcon.f19ec30d5a2d7dba0aa75291206cec38.svg";
export { ForwardRef as ReactComponent };